//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../Features/Features.StructureDesign.ContextAttributeBuilder.js";
import "../no/Expression.js";
import "../Features/Features.StructureDesign.FeatureSpreadsheetBuilder.js";
import "../no/Features.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"AlignmentType",1,0],[0,"AngularTolerance",1,0],[1,"AttachmentFace",0,"ScCollector",0],[0,"AttachmentPointNormal",1,0],[1,"ContextAttribute",0,"Features.StructureDesign.ContextAttributeBuilder",0],[0,"DistanceTolerance",1,0],[1,"FaceOffset",0,"Expression",0],[1,"GussetData",0,"Features.StructureDesign.FeatureSpreadsheetBuilder",0],[0,"HaunchName",1,0],[1,"OffsetDistance",0,"Expression",0],[0,"OrientVector",1,"Direction",0],[0,"PickPointOnAttachment",1,0],[0,"PickPointOnReinforcement",1,0],[0,"PositionType",1,0],[1,"ReinforcementFace",0,"ScCollector",0],[0,"ReinforcementPointNormal",1,0],[0,"ReverseAlignEdge",1,0],[0,"ReverseFlange",1,0],[0,"ReverseStiffeningOnFace",1,0],[1,"StiffeningPlateData",0,"Features.StructureDesign.FeatureSpreadsheetBuilder",0],[0,"StiffeningPlatePlacementMethod",1,0],[0,"ThicknessType",1,0],[1,"XOffset",0,"Expression",0],[1,"YOffset",0,"Expression",0]],[],[]];
SPLM.Features.StructureDesign.HaunchBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.HaunchBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.HaunchBuilder.PlacementMethods = Object.freeze({
    "OnEdge" : "OnEdge", "OnFace" : "OnFace"});

export default SPLM;